/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/14/19
 * Time: 12:10 PM
 */
import React, {Component} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import './Update.css'
import TxtLbl from "../../../../../components/Input/Input/TxtLbl";
import Lbl from "../../../../../components/Label/Lbl";
import {Button, Icon, Input, Form, Checkbox} from "semantic-ui-react";
import LabelDropdown from "../../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import * as common from "../../../../../const/Common/CommonFunc";
import * as EmailValidator from "email-validator";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../../axios/axios_api_services";
import IntlTelInput from "react-intl-tel-input";

class App extends Component {
  state = {
    corporateId: '',
    email: '',
    username: '',
    name: '',
    password: '',
    validatePassword: false,
    isPassword: false,
    corporates_list: [],
    mobile: '',
    format_mobile: '',
    valid_mobile: false,
    status: false
  };

  toggle = () => {
  };
  handleChange = name => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };
  fillData = () => {
    let data = this.props.data;

    this.setState({
      email: data.email,
      username: data.userName,
      name: data.fullName,
      mobile: data.mobile ? data.mobile : "",
      format_mobile: data.mobile ? data.mobile : "",
      valid_mobile: data.mobile ? true : false,
      corporateId: data.corporates.length !== 0 ? data.corporates[0].corporateId : "",
      status: data.status === 1
    })
  };
  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      format_mobile: withdialcode,
      mobile: value,
    });
  };
  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

  getAllCorporate = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            corporates_list: response.data.corporateList
          })
        } else {
          this.setState({
            corporates_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllCorporate()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  handleCorporateChange = (e, {value}) => {
    this.setState({
      corporateId: value
    });
  };
  updateCorAdmin = () => {
    const {email, name, username, corporateId,valid_mobile} = this.state;
    if (email.trim() === "" || name.trim() === "" || username.trim() === "" || corporateId === "") {
      common.notifyMessage("Please enter all required fields");
    } else {
      if (!valid_mobile) {
        common.notifyMessage("Invalid mobile number");
        return;
      }
      let validateEmail = EmailValidator.validate(email);
      if (validateEmail) {
        if (this.state.isPassword) {
          if (this.state.validatePassword) {
            swal({
              title: "Do you want to update corporate admin?",
              icon: are_you_sure_icon,
              closeOnClickOutside: false,
              buttons: {
                cancel: 'Cancel',
                dangerMode: {
                  text: "Yes",
                  value: "action",
                  className: "okay-btn"
                }
              },
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    this.sendToBackend();
                    break;
                  default:
                }
              });
          } else {
            common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS");
          }
        } else {
          this.sendToBackend();
        }
      } else {
        common.notifyMessage("Please enter valid email address");
      }
    }
  };
  sendToBackend = () => {

    const {email, name, username, corporateId, password,format_mobile, status} = this.state;
    let coporateList = [];
    let branchesList = [];

    if (this.props.data.branches.length !== 0) {
      this.props.data.branches.map((branch, index) => {
        branchesList.push(branch.branchId)
      })
    }
    coporateList.push(corporateId);


    const obj = {
      "userId": this.props.data.userId,
      "userName": username,
      "password": password,
      "fullName": name,
      "email": email,
      "status": status ? 1 : 0,
      "userRoles": "CORP_ADMIN",
      "corporates": coporateList,
      "branches": branchesList,
      "mobile": format_mobile
    };

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.post(apiConfig.CORPORATE_SYSTEM_USERS, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Corporate admin successfully updated - (" + username + ")", 0);
          this.props.closeModal();
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        this.props.closeModal();
        this.props.refreshData();
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.fillData();
    this.getAllCorporate();
  }

  render() {

    let corporates_list = this.state.corporates_list;
    let corporates_options = [];
    if (corporates_list.length !== 0) {
      corporates_list.map((cor, index) => {
        const obj = {
          key: index,
          text: cor.corporateName,
          value: cor.corporateId,
          // image: {avatar: true, src: cor.photoPath},
        };
        corporates_options.push(obj)
      })
    }
    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Update Corporate Admin Details</MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
                  <CardHeader>
                    UPDATE CORPORATE ADMIN DETAILS
                  </CardHeader>
                  <CardBody>

                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Email"}
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />

                      </Form.Group>

                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Full Name"}
                          placeholder={"Full name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </Form.Group>

                      <div style={{marginTop: '18px'}}>
                        <Lbl required >Mobile Number</Lbl>
                        <IntlTelInput
                          type={"text"}
                          fieldName={"Mobile Number"}
                          style={{width: '100%', height: '37px'}}
                          value={this.state.mobile}
                          containerClassName="intl-tel-input dashboard-intl"
                          inputClassName="form-control"
                          onPhoneNumberChange={this.onPhoneNumberChange}
                          required={true}
                          preferredCountries={['lk']}
                          defaultCountry={"lk"}
                          nationalMode={false}
                        />
                      </div>
                      <br/>

                      <Lbl required>Join Corporate</Lbl>
                      <LabelDropdown
                        value={this.state.corporateId}
                        noneLable
                        required
                        options={corporates_options}
                        placeholder={"Choose Corporate"}
                        onChange={this.handleCorporateChange}
                      />
                      <br/>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={this.state.status} onChange={() => this.setState({status: !this.state.status})}
                                toggle
                                label={this.state.status ? 'Active' : 'Inactive'}/>
                    </Form>

                  </CardBody>
                </Card>
              </Col>

              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
                  <CardHeader>
                    UPDATE CREDENTIALS
                  </CardHeader>
                  <CardBody>

                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Username"}
                          placeholder={"Username"}
                          value={this.state.username}
                          onChange={this.handleChange('username')}
                        />

                      </Form.Group>

                      <Col className={"none-padding"} lg={12}>
                        <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                  checked={this.state.isPassword}
                                  onChange={() => this.setState({
                                    isPassword: !this.state.isPassword,
                                    password: "",
                                    validatePassword: false
                                  })} toggle
                                  label='Do you want to change admin password'/>

                        {
                          this.state.isPassword ?
                            <div>
                              <Lbl required>Password</Lbl>
                              <Input id={"password-field"}
                                     value={this.state.password}
                                     onChange={this.handleChange('password')}
                                     type={"password"} style={{width: '100%'}}
                                     icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                                 onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                                     placeholder='Password'/>
                            </div>
                            : null
                        }


                      </Col>
                    </Form>

                  </CardBody>
                </Card>
              </Col>

              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Button className="px-5" onClick={this.updateCorAdmin}>Update Corporate Admin</Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
